import React from "react";
import { AppBar, Toolbar, Button, Avatar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// import MenuIcon from "@material-ui/icons/Menu";
import { Link, useHistory, useLocation } from "react-router-dom";
import alliantLogo from "../assets/images/alliant-logo.svg";
import { useAppAuth } from "../auth/app-auth";
// import logo from './images/1_a.png'

const NavigationBar = (props) => {
  const styles = useStyles();
  const history = useHistory();
  const { isAuthenticated, logout, user, loading } = useAppAuth() || {};
  const currentLocation = useLocation().pathname;
  return (
    <div>
      <AppBar position="static" className={styles.appBar} elevation={1}>
        <Toolbar className={styles.toolbar}>
          <Link to={{ pathname: "/" }}>
            <img className={styles.logo} src={alliantLogo} alt="logo" />
          </Link>
          {currentLocation !== "/" && (
            <Typography
              component="div"
              variant="h5"
              className={styles.currentNavigationLabel}
            >
              The Board Shield
            </Typography>
          )}
          <Link to={{ pathname: "/dashboard" }} className={styles.navIcon}>
            Dashboard
          </Link>
          {isAuthenticated && user?.role === "owner" && (
            <Link to={{ pathname: "/users" }} className={styles.navIcon}>
              Users
            </Link>
          )}
          <div className={styles.padding}></div>
          {isAuthenticated && user?.name && (
            <Typography className={styles.userLabel}>
              {user.name}
            </Typography>
          )}
          {isAuthenticated && (
            <Button
              classes={{
                label: styles.logoutLabel,
              }}
              disabled={!isAuthenticated}
              onClick={() => {
                logout();
                history.push("/");
              }}
              style={{ fontSize: 16 }}
            >
              Logout
            </Button>
          )}
          {isAuthenticated && !loading && user?.picture && (
            <Avatar alt="Current User" src={user.picture} />
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default NavigationBar;

const useStyles = makeStyles((theme) => {
  return {
    toolbar: {
      display: "flex",
    },
    padding: {
      flexGrow: 1,
    },
    logoutLabel: {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(3),
    },
    appBar: {
      backgroundColor: theme.palette.background.paper,
      minHeight: "50px",
      padding: "15px",
      zIndex: theme.zIndex.drawer + 1,
      position: "fixed",
    },
    logo: {
      width: "auto",
      height: "50px",
      marginRight: theme.spacing(3),
    },
    currentNavigationLabel: {
      color: theme.palette.text.primary,
    },
    navIcon: {
      padding: '8px',
      color: 'white',
      fontSize: '24px',
      marginLeft: '16px',
    },
    userLabel: {
      color: theme.palette.text.primary,
      marginRight: theme.spacing(2),
    },
  };
});
